import React from 'react';

const Features = () => {
    return (
        <div className="features-section">
            <h2>Почему выбирают нас</h2>
            <div className="features-grid">
                <div className="feature-card">
                    <div className="feature-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <h3>Гарантия качества</h3>
                    <p>Все автомобили проходят тщательную проверку перед продажей</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <h3>Выгодные условия</h3>
                    <p>Кредит и специальные предложения для наших клиентов</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <h3>Техническая поддержка</h3>
                    <p>Сервисное обслуживание и ремонт вашего автомобиля</p>
                </div>
            </div>

            <style jsx>{`
        .features-section {
          margin-top: 3rem;
          margin-bottom: 2rem;
        }
        
        .features-section h2 {
          text-align: center;
          margin-bottom: 2rem;
          font-size: 2rem;
        }
        
        .features-grid {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          gap: 2rem;
        }
        
        .feature-card {
          background-color: white;
          padding: 2rem;
          border-radius: 0.375rem;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
          text-align: center;
          flex: 1;
        }
        
        .feature-icon {
          margin: 0 auto 1rem;
          width: 3rem;
          height: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(23, 23, 23, 0.1);
          color: #171717;
          border-radius: 50%;
        }
        
        .feature-card h3 {
          margin-bottom: 0.5rem;
        }
        
        .feature-card p {
          color: #666666;
        }
        
        @media (max-width: 768px) {
          .features-grid {
            flex-direction: column;
          }
        }
      `}</style>
        </div>
    );
};

export default Features;